import React from 'react';
import cn from 'classnames';
import { BellLiner24 } from 'seagull/icons';
import { useEventReporter } from "../../../event-reporter";
import { useStore, useStoreActions } from "../../../store/store-context";
import { selectors } from "../../../store/state-selectors";
import styles from "./InAppNotificationsButton.module.scss";
export function InAppNotificationsButton() {
  const {
    setInAppNotificationsDrawerOpen,
    logBI
  } = useStoreActions();
  const showNotificationPimple = useStore(state => state.showNotificationPimple);
  const inAppNotificationsDrawerOpen = useStore(state => state.inAppNotificationsDrawerOpen);
  const email = useStore(selectors.user.email);
  const {
    reportToHeap
  } = useEventReporter();
  const triggerIcon = /*#__PURE__*/React.createElement("div", {
    className: cn(styles.iconContainer, {
      [styles.active]: inAppNotificationsDrawerOpen
    })
  }, /*#__PURE__*/React.createElement(BellLiner24, null), showNotificationPimple && /*#__PURE__*/React.createElement("div", {
    className: styles.pimple,
    "data-testid": "home-sidebar-notification-center-pimple"
  }));
  const handleClick = () => {
    logBI(15000);
    reportToHeap('sidebar', 'click', 'vendor-clicked-notifications-btn', {
      email
    });
    setInAppNotificationsDrawerOpen(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: cn(styles.root, {
      [styles.active]: inAppNotificationsDrawerOpen
    }),
    "data-testid": "home-sidebar-notification-center",
    onClick: handleClick
  }, triggerIcon);
}